var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-toolbar',{attrs:{"app":"","fixed":"","clipped-left":""}},[_c('v-toolbar-title',[_vm._v("Srđan Nikolić")])],1),_c('v-content',[_c('resume')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }